import { Component, Injectable } from "@angular/core";
import { SignalsMainComponent } from "./main.component";

@Component({
  selector: "app-signals-scheduled",
  template: `<app-signals-messages [isScheduled]='true' title="Scheduled"></app-signals-messages>`,
  styleUrls: ["../styles/signalsMessages.component.css"],
})
@Injectable()
export class SignalsScheduledComponent extends SignalsMainComponent {
}


// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signalsScheduled.component.ts